// extracted by mini-css-extract-plugin
module.exports = {"modalDialog":"styles_modalDialog__2zBGo","modalContent":"styles_modalContent__3vTR0","rodoCompButton":"styles_rodoCompButton__3DYfh","closeSign":"styles_closeSign__3ZyHd"};